import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage({ compact = false }) {
  return (
    <div className={`${compact ? "min-h-[65dvh]" : "min-h-screen"} flex flex-col items-center justify-center bg-slate-50 px-6 text-center`}>
      <h1 className="text-6xl font-extrabold text-[#013D4E] mb-4">404</h1>
      <h2 className="text-2xl font-bold mb-2 text-gray-800 ">الصفحة غير موجودة</h2>
      <p className="mb-6 text-gray-500 ">عذراً، الصفحة التي تبحث عنها غير متوفرة أو تم نقلها.</p>
      <Link
        to={compact ? "/admin" : "/"}
        className="bg-[#013D4E] text-white px-6 py-2 rounded hover:bg-indigo-700 font-bold"
      >
        {compact ? "العودة للوحة التحكم" : "العودة للصفحة الرئيسية"}
      </Link>
    </div>
  );
}
